import axios from "../axios";

export default class VegaContingecy {
  async getContingecyStatus() {
    let res = await axios.get("Contingency/VegaStatusContingency");
    return res.data;
  }
}
